import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";
import { convexClient, crossDomainClient } from "@convex-dev/better-auth/client/plugins";

const authBaseUrl =
  import.meta.env.VITE_CONVEX_SITE_URL || import.meta.env.VITE_CONVEX_URL;

if (!authBaseUrl) {
  throw new Error(
    "Missing auth base URL: set VITE_CONVEX_SITE_URL (or VITE_CONVEX_URL fallback)."
  );
}

export const authClient = createAuthClient({
  baseURL: authBaseUrl,
  plugins: [convexClient(), crossDomainClient(), magicLinkClient()],
});

// Re-export hooks for convenience
export const {
  signIn,
  signOut,
  useSession,
} = authClient;

// Types for the user
export interface User {
  id: string;
  email: string;
  name: string | null;
  isAdmin: boolean;
  isProvisionedClient: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Session {
  id: string;
  userId: string;
  expiresAt: Date;
}
